module.exports = __webpack_public_path__ + "static/img/qr-code-show-head.32401bfe.png";